<template lang="pug">
  header.position-relative.bg-page.home-hero
    ParallaxBackground.text-center
      img(:src="moodImage.src" :alt="moodImage.alt" style="max-width:200%;")
    .search-box-wrapper.px-4.pb-4.px-md-5.pb-md-5.pt-4.position-absolute(style="z-index:1;")
      h2.text-center.h1.w-100.txt-td-grey-dark Wo soll die nächste Reise hingehen?
      .position-relative
        .position-absolute.w-100.pb-3.popup(v-if="popularQueries && popularQueries.length")
          .popular-queries(:class="{active:showsPopularQueries}")
            .p-2.text-center.bg-white.content
              b.txt-td-grey-dark Beliebte Anfragen:
                .d-inline-flex.flex-wrap.align-items-center.justify-content-center
                  span.p-2.txt-white.bg-tdays-basic.rounded.tag.font-weight-light(v-for="query in popularQueries" @click="useQueryValue(query)") {{query}}
        SearchBox(v-model="searchValue" :suggestions="searchSuggestions" :show-loading-indicator="isFetchingSuggestions" @focus="focusSearchBox" @input="fetchSuggestions" @blur="blurSearchBox" @submit="startSearch" ref="searchBox")
</template>

<script>
import SearchBox from "@/views/components/search/SearchBox";
import config from "@/config/config";
import axios from "axios";
import ParallaxBackground from "@/views/components/partials/ParallaxBackground.vue";
import { HostSearch } from "@/graphql/HostSearch.ts";
import { fetchSuggestions } from "@/lib/helper/search";
import { randomElement } from "@/lib/helper/math";

export default {
  name: "HomeHero",
  components: {
    ParallaxBackground,
    SearchBox
  },
  setup() {
    const analyticsAdapter = axios.create({
      baseURL: `${config.external.elastic.endpointBase}/api/as/v1/engines/search-items/analytics/`,
      headers: {
        "Content-Type": "application/json;charset=utf8",
        Authorization: `Bearer ${config.external.elastic.privateKey}`
      }
    });

    let observer = undefined;

    const moodImages = [
      { src: "https://s3-cloud.td-cdn.de/Images/moloss/home/startseite-mood-fruehling.jpg" },
      { src: "https://s3-cloud.td-cdn.de/Images/moloss/home/startseite-mood-fruehling2.jpg" },
      { src: "https://s3-cloud.td-cdn.de/Images/moloss/home/startseite-mood-fruehling3.jpg" }
    ];

    const moodImage = randomElement(moodImages);
    return { analyticsAdapter, observer, moodImage };
  },
  data() {
    return {
      searchValue: "",
      popularQueries: [],
      showsPopularQueries: false,
      scrollPosition: 0,
      trackScroll: true,
      isFetchingSuggestions: false,
      searchSuggestions: []
    };
  },
  methods: {
    async fetchSuggestions(term) {
      this.isFetchingSuggestions = true;
      try {
        this.searchSuggestions = await fetchSuggestions(this.$apollo, term);
      } finally {
        this.isFetchingSuggestions = false;
      }
    },
    focusSearchBox() {
      this.showsPopularQueries = true;
      if (this.searchValue.trim().length) return;
      this.$scrollTo("#home");
    },
    blurSearchBox() {
      this.showsPopularQueries = false;
    },
    startSearch() {
      this.$router.push({ name: "Search", query: { query: this.searchValue } });
    },
    useQueryValue(value) {
      if (!value?.trim()?.length) return;
      this.searchValue = value;
      this.startSearch();
    },
    async getMostSearchedQueries() {
      return await this.$apollo.query({
        query: HostSearch.Queries.MostSearchedTerms
      }).then((response) => response?.data?.mostSearchedTerms || []);
    },
    trackScrollPosition() {
      //this.showsPopularQueries = false;
      //const searchBoxInput = this.$refs.searchBox?.$el?.querySelector("input");
      //if (searchBoxInput) searchBoxInput.blur();
      //if (!this.trackScroll) return;
      //this.scrollPosition = window.scrollY;
    }
  },
  created() {
    //this.observer = new IntersectionObserver(([entry]) => {
    //  this.trackScroll = entry.isIntersecting;
    //});
  },
  async mounted() {
    try {
      this.popularQueries = await this.getMostSearchedQueries();
    } catch (e) {
      this.$log.error(e);
    }
  },
  unmounted() {
    window.removeEventListener("scroll", this.trackScrollPosition);
    this.observer.disconnect();
  }
};
</script>
<style lang="scss">
@import "@/assets/styles/mediaqueries";

.home-hero {
  .search-box-wrapper {
    .search-box {
      --border-radius: 7px;

      input {
        border-top-left-radius: var(--border-radius);
        border-bottom-left-radius: var(--border-radius);
        border-top-right-radius: var(--border-radius);
        border-bottom-right-radius: var(--border-radius);
        @include md {
          border-top-left-radius: var(--border-radius);
          border-bottom-left-radius: var(--border-radius);
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }

      button {
        border-top-right-radius: var(--border-radius);
        border-bottom-right-radius: var(--border-radius);
      }

      .suggestions {
        max-height: clamp(120px, 50vh, 200px);
      }
    }
  }
}
</style>
<style scoped lang="scss">
@import "@/assets/styles/_colors";
@import "@/assets/styles/mediaqueries";

header {
  overflow: hidden;
  margin-bottom: -300px;
  height: 80vh;
  min-height: 600px;

  @media screen and (max-height: 1000px) {
    margin-bottom: -185px;
  }

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    height: 300px;
    width: 150%;
    left: 50%;
    background-color: inherit;
    transform: translate(-50%, 30%) rotate(-5deg);
  }

  .search-box-wrapper {
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 50px);
    max-width: 720px;
    backdrop-filter: blur(7px);
    background-color: rgba($white, 0.35);
    border-radius: 10px;

    @include xs {
      top: 50%;
    }
    @include md {
      top: 20%;
    }

    .popup {
      top: 0;
      left: 0;
      transform: translate(0px, -100%);
    }

    .popular-queries {
      position: relative;
      z-index: 1;
      opacity: 0;
      transform: translate(0, -10px);
      transition: transform 0.4s, opacity 0.4s;

      &.active {
        opacity: 1;
        transform: translate(0, 0);
      }

      &::before {
        content: "";
        width: 15px;
        aspect-ratio: 1;
        background-color: $white;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 50%) rotate(45deg);
      }

      .content {
        border-radius: 5px;
        box-shadow: 0 3px 3px rgba($td-grey-darker, 0.15);
      }
    }
  }

  .td-logo {
    max-width: 120px;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 50%);
    border-radius: 50%;
    backdrop-filter: blur(10px);
    background-color: rgba($td-grey-darker, 0.75);
  }
}

.shadowed-text {
  text-shadow: 2px 2px 0px rgba($td-grey-darker, 0.25);
}

.tag {
  margin: 0.25rem;
  cursor: pointer;
  transition: box-shadow 0.4s;

  &:hover {
    box-shadow: 0 0 5px rgba($td-grey-darker, 0.25);
  }
}
</style>
